import { createShareUrl, normalizeText } from './maps.js'
import { applyDocumentLocale, formatLocalizedBombCount, t } from './i18n.js'

const SITE_NAME = 'Build & Destroy'
const X_SHARE_ATTRIBUTION = '#vibejam created by @domenicodd'

export function createResultShareUrl(build, attempt, baseUrl = window.location.href) {
    const url = new URL(createShareUrl(build, baseUrl))

    if (attempt?.id) {
        url.searchParams.set('attempt', attempt.id)
    }

    return url.toString()
}

export function createXShareUrl({ build, shareUrl, result = null }) {
    const url = new URL('https://twitter.com/intent/tweet')
    url.searchParams.set('text', result?.won ? createResultShareText(build, result) : createBuildShareText(build))
    url.searchParams.set('url', shareUrl)
    return url.toString()
}

export function updateBuildShareMeta(build, shareUrl = window.location.href) {
    updateOpenGraphMeta({
        title: `${build.title} | ${SITE_NAME}`,
        description: t('meta.buildDescription', { title: build.title, builderName: build.builderName }),
        imageUrl: build.ogImageUrl,
        url: shareUrl
    })
}

export function updateResultShareMeta({ build, attempt, shareUrl = window.location.href }) {
    if (!attempt?.won || !attempt?.ogImageUrl) {
        updateBuildShareMeta(build, shareUrl)
        return
    }

    updateOpenGraphMeta({
        title: t('meta.resultTitle', {
            destroyerName: attempt.destroyerName,
            title: build.title,
            siteName: SITE_NAME
        }),
        description: t('meta.resultDescription', { bombs: formatLocalizedBombCount(attempt.bombsUsed) }),
        imageUrl: attempt.ogImageUrl,
        url: shareUrl
    })
}

export function updateDefaultShareMeta() {
    updateOpenGraphMeta({
        title: t('meta.defaultTitle'),
        description: t('meta.defaultDescription'),
        imageUrl: absoluteUrl('/art/social-fallback.png'),
        url: window.location.href
    })
}

function createBuildShareText(build) {
    return addXShareAttribution(t('share.buildText', { title: build.title, siteName: SITE_NAME }))
}

function createResultShareText(build, result) {
    const destroyerName = normalizeText(result.destroyerName, t('defaults.destroyer'), 40)
    return addXShareAttribution(t('share.resultText', {
        destroyerName,
        title: build.title,
        bombs: formatLocalizedBombCount(result.bombsUsed),
        siteName: SITE_NAME
    }))
}

function addXShareAttribution(text) {
    return `${text}\n\n${t('share.attribution') || X_SHARE_ATTRIBUTION}`
}

function updateOpenGraphMeta({ title, description, imageUrl, url }) {
    applyDocumentLocale()
    document.title = title
    setMeta('property', 'og:site_name', SITE_NAME)
    setMeta('property', 'og:type', 'website')
    setMeta('property', 'og:title', title)
    setMeta('property', 'og:description', description)
    setMeta('property', 'og:url', url)
    setMeta('name', 'twitter:card', 'summary_large_image')
    setMeta('name', 'twitter:title', title)
    setMeta('name', 'twitter:description', description)

    if (imageUrl) {
        const resolvedImageUrl = absoluteUrl(imageUrl)
        setMeta('property', 'og:image', resolvedImageUrl)
        setMeta('property', 'og:image:width', '1200')
        setMeta('property', 'og:image:height', '630')
        setMeta('name', 'twitter:image', resolvedImageUrl)
    }
}

function setMeta(attribute, key, content) {
    let element = document.head.querySelector(`meta[${attribute}="${key}"]`)

    if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attribute, key)
        document.head.appendChild(element)
    }

    element.setAttribute('content', content)
}

function absoluteUrl(value) {
    return new URL(value, window.location.origin).toString()
}
